import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
    selector: '[cwDebounceKeyUp]',
    standalone: false,
})
export class DebounceKeyUpDirective implements OnInit, OnDestroy {
    @Input() cwDebounceKeyUpTime = 500;

    @Output() cwDebounceKeyUp = new EventEmitter();

    private clicks = new Subject<Event>();
    private subscription!: Subscription;

    ngOnInit(): void {
        this.subscription = this.clicks.pipe(debounceTime(this.cwDebounceKeyUpTime)).subscribe((e: Event) => this.cwDebounceKeyUp.emit(e));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    @HostListener('keyup', ['$event'])
    keyUpEvent(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this.clicks.next(event);
    }
}
